import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { AssocArray } from 'tools/types';

// Overrides URL GET params as the source of filter values, for viewers embedded into a host page
// (e.g. `element_viewer` shared component) where the page URL does not belong to the report.
export const FilterRequestParamsContext = React.createContext<AssocArray<Array<string>> | null>(null);

const normalizeKey = (key: string) => (key.endsWith('[]') ? key.slice(0, -2) : key);

export function parseFilterRequestParams(search: string): AssocArray<Array<string>> {
    const result: AssocArray<Array<string>> = {};
    if (!search.length) {
        return result;
    }
    const urlParam = new URLSearchParams(search);
    for (const key of urlParam.keys()) {
        result[normalizeKey(key)] = urlParam.getAll(key);
    }
    return result;
}

// Filters passed by the host via FilterRequestParamsContext take priority; otherwise they are read from URL GET params.
export function useFilterRequestParams(): AssocArray<Array<string>> {
    const location = useLocation();
    const contextParams = useContext(FilterRequestParamsContext);
    return contextParams ?? parseFilterRequestParams(location.search);
}
